/** @format */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { resetPassword } from "../store/admin/admin.action";
import { useParams } from "react-router-dom";
import Input from "../extra/Input";
import Button from "../extra/Button";
import Declotr from "../../assets/images/DeclotrImage.png";
import loginlogo2 from "../../assets/images/loginlogo2.png";

const ChangePassword = () => {
	const dispatch = useDispatch();

	const searchParams = new URLSearchParams(window.location.search);

	const adminId = searchParams.get("id");

	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [error, setError] = useState({
		newPassword: "",
		confirmPassword: "",
	});

	const handleChangePassword = () => {
		if (!newPassword || !confirmPassword || newPassword !== confirmPassword) {
			let error = {};

			if (!newPassword) error.newPassword = "New Password Is Required !";

			if (!confirmPassword) error.confirmPassword = "Confirm Password Is Required !";
			if (newPassword !== confirmPassword) error.confirmPassword = "New Password and Confirm Password doesn't match";
			return setError({ ...error });
		} else {
			let data = {
				confirmPassword: confirmPassword,
				newPassword: newPassword,
			};
			dispatch(resetPassword(adminId, data));
		}
	};

	return (
		<>
			<div className='mainLoginPage'>
				<div className='loginDiv'>
					<div className='row'>
						<div className='col-xl-6 d-xxl-block d-xl-block d-none boxCenter p-5' style={{ background: "#E54A13" }}>
							<img className='img-fluid' src={Declotr} alt='text logo' style={{ maxWidth: "200px", marginBottom: "20px" }} />
							<img className='img-fluid' src={loginlogo2} alt='login logo' />
						</div>
						<div className='col-xl-6 col-md-12 boxCenter' style={{ background: "#FEFEFE" }}>
							<div className='loginDiv2'>
								<div className='loginPage pt-3'>
									<div className='my-4'>
										<div className='loginLogo me-3 pt-1 pe-1'>
											<img src={require("../../assets/images/Eralogo22.png")} alt='' width={"80px"} />
										</div>
									</div>
									<div
										style={{
											color: "#000",
											fontSize: "16px",
											fontWeight: "400",
											lineHeight: "22px",
											letterSpacing: "0.48px",
										}}>
										<p>Forgot your password?</p>
									</div>
									<div className='mb-3'>
										<h3 className='fw-bold text-dark' style={{ fontSize: "46px", fontWeight: "600" }}>
											Reset Password
										</h3>
									</div>

									<div className='loginInput'>
										<Input
											label={`New Password`}
											id={`New Password`}
											type={`password`}
											value={newPassword}
											errorMessage={error.newPassword && error.newPassword}
											onChange={(e) => {
												setNewPassword(e.target.value);
												if (!e.target.value) {
													return setError({
														...error,
														newPassword: `New Password Is Required`,
													});
												} else {
													return setError({
														...error,
														newPassword: "",
													});
												}
											}}
										/>

										<Input
											label={`Confirm Password`}
											id={`Confirm Password`}
											type={`password`}
											value={confirmPassword}
											errorMessage={error.confirmPassword && error.confirmPassword}
											onChange={(e) => {
												setConfirmPassword(e.target.value);
												if (!e.target.value) {
													return setError({
														...error,
														confirmPassword: `Confirm Password Is Required`,
													});
												} else {
													return setError({
														...error,
														confirmPassword: "",
													});
												}
											}}
										/>
									</div>

									<div className='loginButton d-flex justify-content-center mt-5'>
										<Button
											newClass={`blackFont ms-3`}
											btnColor={`btnBlackPrime`}
											style={{
												borderRadius: "20px",
												width: "170px",
												height: "46px",
												color: "#fff",
											}}
											btnName={`Reset Password`}
											onClick={handleChangePassword}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ChangePassword;
